import React from "react";
import PageHero from "@/components/PageHero";
import { Container } from "@/components/shared";

const sections = [
  { h: "Who we are", p: "Made in Boston is an independent project run by a private citizen. We are the data controller for information you provide through this website. We are not a public authority." },
  { h: "What we collect", p: "If you create an account, we store your name, email address, and a securely hashed password. If you submit a listing, an enquiry, an introduction, or a contact message, we store what you send us so it can reach the right person." },
  { h: "How we use it", p: "We use your details only to run the crossing: to show approved listings, to pass enquiries to the relevant maker, to consider introductions, and to reply to you. We do not sell your data." },
  { h: "Storage and security", p: "Passwords are hashed and never stored in plain text. We keep submissions only as long as they are useful to the project. This preview stores data in our own database." },
  { h: "Your rights", p: "You may ask us to show, correct, or delete the personal data we hold about you. Write to info@madeinboston.co.uk and we will respond." },
  { h: "Cookies", p: "We use only what is needed to keep you signed in. We do not run advertising trackers on this site." },
];

export default function Privacy() {
  return (
    <div>
      <PageHero kicker="Privacy" title="Privacy notice" intro="Plainly put: we keep only what we need to run the crossing, and we look after it." />
      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-8">
            {sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-xl text-[#003366] mb-2">{s.h}</h2>
                <p className="font-sans text-base text-[#1B2430] leading-relaxed">{s.p}</p>
              </div>
            ))}
            <p className="font-sans text-sm text-[#505A68] pt-6 border-t border-[#D6D3CB]">
              This is an independent project. Not a local authority website.
            </p>
          </div>
        </Container>
      </section>
    </div>
  );
}
